<template>
	<div
		class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-2"
	>
		<!-- semi -->
		<!-- the admin-crop-grid component is too complex in layout for this use,
             as it contains title and margin, among other things.
             It is used as a 'whole page view' in admin – here it is only used as a table.
             -->
		<!-- unmaintainable wrapper -->
		<div class="semi-6100 -m-4">
			<admin-crop-grid
				:rows="allPriceIndications"
				:cols="cols"
				:defaultOrderBy="null"
				:should-paginate="false"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		groupedPriceIndications: {
			type: Array,
			required: true,
		},
	},
	computed: {
		allPriceIndications() {
			let cols = this.groupedPriceIndications.flatMap((g) => g.items);
			cols.forEach((item) => {
				item.offer_buy.thread_id = item.thread_id;
			});
			return cols;
		},
	},
	data() {
		let that = this;
		return {
			cols: [
				{
					id: "product__grade",
					name: "Artikel",
					render: (x, row) =>
						this.$cropOptions.getLocalizedLabel(
							row.offer_buy.product__grade,
							this.$cropOptions.productGradeOptions
						) +
						" " +
						row.offer_buy.product__harvest,
				},
				{
					id: "date_info",
					name: "Termin",
					render: function (x, row) {
						let ret = that.$cropOptions.getLocalizedLabel(
								row.offer_buy.date__type,
								that.$cropOptions.dateModeOptions
							),
							m = [
								row.offer_buy.date__month_from
									? that.$cropOptions.dateToMonthLocalizedString(
											row.offer_buy.date__month_from
									  )
									: null,
								row.offer_buy.date__month_to
									? that.$cropOptions.dateToMonthLocalizedString(
											row.offer_buy.date__month_to
									  )
									: null,
							]
								.filter((e) => e != null)
								.join(" - ");
						if (m) {
							ret = ret + " " + m;
						}
						return ret;
					},
				},
				{
					id: "price__mt",
					name: "Frei Fuhre Preis",
					render: (x, row) => x + " €",
				},
				{
					id: "change",
					name: "",
					component: "price-indications-price-change",
				},
				{
					id: "offer_buy",
					name: "Aktion",
					component: "price-indications-grid-action-col",
				},
			],
		};
	},
};
</script>
